import React from 'react';
import { useI18n } from '@shopify/react-i18n';
import enTranslations from './translations/en.json';
import frTranslations from './translations/fr.json';

const translationsByLocale = { en: enTranslations, fr: frTranslations };

/**
 * PendingApproval
 *
 * Shown to merchants whose store has been explicitly blocked by MDF (isApproved = false).
 * Directs them to register their brand on marques-de-france.fr.
 */
export default function PendingApproval() {
  const [i18n] = useI18n({
    id: 'PendingApproval',
    fallback: enTranslations,
    translations(locale) {
      return translationsByLocale[locale] ?? enTranslations;
    },
  });

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: '20px',
      padding: '32px 24px',
      textAlign: 'center',
      boxSizing: 'border-box',
    }}>
      <s-badge icon="alert-circle" style={{ fontSize: '16px', padding: '12px 20px' }}>
        {i18n.translate('PendingApproval.title')}
      </s-badge>

      <s-text tone="subdued" style={{ maxWidth: '480px' }}>
        {i18n.translate('PendingApproval.description')}
      </s-text>

      <s-text tone="subdued" style={{ maxWidth: '480px' }}>
        {i18n.translate('PendingApproval.registerBefore')}{' '}
        <a
          href="https://www.marques-de-france.fr/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit' }}
        >
          {i18n.translate('PendingApproval.registerLink')}
        </a>
        {i18n.translate('PendingApproval.registerAfter')}
      </s-text>
    </div>
  );
}
